import AxiosInstance from "./apiClient";

// Updates consultation status for a user submission
export const updateConsultationStatusApi = async ({
  userSubmissionId,
  consultationType,
  paymentMethodId,
}) => {
  const url = `user-submission/update-consultation-status/${userSubmissionId}`;
  const payload = { consultationType };
  if (paymentMethodId) {
    payload.paymentMethodId = paymentMethodId;
  }

  try {
    const res = await AxiosInstance.patch(url, payload);
    return res?.data;
  } catch (error) {
    console.log("Error updating consultation status:", error);
    throw error;
  }
};
